module.exports = __webpack_public_path__ + "static/media/photo3.8c5c4981.jpg";